import { colors, fonts } from '@grupoboticario/flora-tokens/truss/web/ds'

export const truss = {
  colors,
  fonts,
}
